import GlyphIcon from "./GlyphIcon.mjs";

/**
 * Glyphicon 111-paragrapfh-left
 * @see {GlyphIcon}
 */
const ParagraphLeft = class extends GlyphIcon {
	constructor(props) {
		super(props);
		this.state.d="M4,7V6A1,1,0,0,1,5,5H16a1,1,0,0,1,1,1V7a1,1,0,0,1-1,1H5A1,1,0,0,1,4,7Zm23,4H5a1,1,0,0,0-1,1v1a1,1,0,0,0,1,1H27a1,1,0,0,0,1-1V12A1,1,0,0,0,27,11ZM5,20H18a1,1,0,0,0,1-1V18a1,1,0,0,0-1-1H5a1,1,0,0,0-1,1v1A1,1,0,0,0,5,20Zm22,3H5a1,1,0,0,0-1,1v1a1,1,0,0,0,1,1H27a1,1,0,0,0,1-1V24A1,1,0,0,0,27,23Z";
	}
}

export default ParagraphLeft;